export const shouldSaveKeyInCookie = (key: string) => {
  return (
    key.indexOf('.refreshToken') > -1 ||
    key.indexOf('.LastAuthUser') > -1 ||
    key.indexOf('.accessToken') > -1
  );
};
